import React, { ComponentProps } from 'react';
import { Route, withRouter, RouteComponentProps } from 'react-router-dom';

import { fomatParentPath } from '../../utils';
import { MobAppQrcode } from '../../lib';

function RouteMobAppQrcode(props: RouteComponentProps & ComponentProps<any>) {
  const parentPath: string = fomatParentPath(props);
  return (
    <Route weId={`${props.weId || ''}_x7eiky`} exact path={`${parentPath}/mobile/uk/qrcode`}>
      {
        <MobAppQrcode weId={`${props.weId || ''}_jx0jn02`} />
      }
    </Route>
  )
}

export default withRouter(RouteMobAppQrcode);